import { DialogRef } from '@angular/cdk/dialog';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { SvgIconComponent } from '@ngneat/svg-icon';
import { TagEvent, TagPusherService } from '@libs/shared-services';

export interface DeleteAccountModalComponentResult {
  deleteAccount: boolean;
}

@Component({
  selector: 'lib-delete-account-modal',
  standalone: true,
  imports: [CommonModule, TranslateModule, SvgIconComponent],
  templateUrl: './delete-account-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DeleteAccountModalComponent {
  private readonly dialogRef = inject(DialogRef);
  private readonly translate = inject(TranslateService);
  private readonly tagPusherService = inject(TagPusherService);

  protected get deleteAccountMailtoLink(): string {
    const email = this.translate.instant('account_help_contact_express_delete_account_email');
    const subject = this.translate.instant('account_help_contact_express_delete_account_subject');
    const body = this.translate.instant('account_help_contact_express_delete_account_body');

    return `mailto:${email}?subject=${subject}&body=${encodeURIComponent(body)}`;
  }

  public onCloseDialog(): void {
    this.dialogRef.close({
      deleteAccount: false,
    });
  }

  public onRequestDeleteClick(): void {
    this.tagPusherService.pushTag({
      event: TagEvent.FfdNotesAccountDeleteRequest,
    });
    this.dialogRef.close({ deleteAccount: true });
  }
}
